import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flexRow pb-5" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "control-label" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "control-label" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "control-label" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "control-label" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "mb-1" }
const _hoisted_33 = { class: "mb-1" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_35 = { class: "fs-22" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "control-label" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_40 = { class: "pull-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_preziario = _resolveComponent("preziario")!
  const _component_accordion = _resolveComponent("accordion")!
  const _component_payment_config_details = _resolveComponent("payment-config-details")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary float-right",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Salva",
          text: "Salva"
        })
      ]),
      _createElementVNode("h4", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Dettaglio Categoria",
          text: "Dettaglio Categoria"
        })
      ]),
      _hoisted_3,
      (_ctx.category)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Nome",
                  text: "Nome"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.category.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.category.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Tipo prodotti",
                  text: "Tipo prodotti"
                })
              ]),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.category.categoryType) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryTypes, (item, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: item
                  }, _toDisplayString(item), 9, _hoisted_7))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.category.categoryType]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Display Order",
                  text: "Display Order"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "number",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.category.order) = $event))
              }, null, 512), [
                [_vModelText, _ctx.category.order]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Usa carrello",
                  text: "Usa carrello"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control checkBig",
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.category.useShoppingCart) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.category.useShoppingCart]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Imposta come categoria di upsell (può essere soltanto una)",
                  text: "Imposta come categoria di upsell (può essere soltanto una)"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control checkBig",
                type: "checkbox",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.category.isUpsellCategory) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.category.isUpsellCategory]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "MinProductLevelRequired (livello minimo per poter vedere la categoria)",
                      text: "MinProductLevelRequired (livello minimo per poter vedere la categoria)"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "number",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.category.minProductLevelRequired) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.category.minProductLevelRequired,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "MaxProductLevelRequired (livello massimo per poter vedere la categoria)",
                      text: "MaxProductLevelRequired (livello massimo per poter vedere la categoria)"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "number",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.category.maxProductLevelRequired) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.category.maxProductLevelRequired,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Filtro per nazione (se nessuna selezionata, visibile a tutti)",
                      text: "Filtro per nazione (se nessuna selezionata, visibile a tutti)"
                    })
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.nazioneFilter, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: item }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-danger",
                        onClick: ($event: any) => (_ctx.removeNazione(item, i))
                      }, "x", 8, _hoisted_22),
                      _createTextVNode(" " + _toDisplayString(item), 1)
                    ]))
                  }), 128)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tempNazione) = $event)),
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.selectNazione && _ctx.selectNazione(...args))),
                    disabled: _ctx.filteredNaziones.length == 0
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNaziones, (nazione, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: nazione
                      }, _toDisplayString(nazione.name), 9, _hoisted_24))
                    }), 128))
                  ], 40, _hoisted_23), [
                    [_vModelSelect, _ctx.tempNazione]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Filtro per ruolo (se nessuno selezionato, visibile a tutti)",
                      text: "Filtro per ruolo (se nessuno selezionato, visibile a tutti)"
                    })
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.rolesFilter, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: item }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-danger",
                        onClick: ($event: any) => (_ctx.removeRole(item, i))
                      }, "x", 8, _hoisted_28),
                      _createTextVNode(" " + _toDisplayString(item), 1)
                    ]))
                  }), 128)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tempRole) = $event)),
                    onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.selectRole && _ctx.selectRole(...args))),
                    disabled: _ctx.filteredRoles.length == 0
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRoles, (role, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: role
                      }, _toDisplayString(role), 9, _hoisted_30))
                    }), 128))
                  ], 40, _hoisted_29), [
                    [_vModelSelect, _ctx.tempRole]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Usa i requirements per filtrare le offerte (ogni offerta sarà visibile in base alle offerte acquistate dal cliente)",
                  text: "Usa i requirements per filtrare le offerte (ogni offerta sarà visibile in base alle offerte acquistate dal cliente)"
                })
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Ogni offerta potrà essere <b>ACQUISTATA UNA VOLTA SOLA</b>",
                  text: "Ogni offerta potrà essere <b>ACQUISTATA UNA VOLTA SOLA</b>"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control checkBig",
                type: "checkbox",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.category.useOfferRequirements) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.category.useOfferRequirements]
              ])
            ]),
            _hoisted_34,
            _createVNode(_component_accordion, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Spese di spedizione",
                    text: "Spese di spedizione"
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Soglia per spedizione gratuita",
                      text: "Soglia per spedizione gratuita"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "number",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.category.speseSpedizioneConfig.soglia) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.category.speseSpedizioneConfig.soglia,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createVNode(_component_preziario, {
                  modelValue: _ctx.category.speseSpedizioneConfig.preziario,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.category.speseSpedizioneConfig.preziario) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_38,
            _createVNode(_component_payment_config_details, {
              modelValue: _ctx.category.paymentConfigDetails,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.category.paymentConfigDetails) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Salva",
                  text: "Salva"
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}